import React, { useContext, useEffect } from "react"
import Headers from "./components/Header"
import Blogs from "./components/Blogs"
import Pagination from "./components/Pagination"
import { AppContext } from "./context/AppContext";
import "./App.css"

const App=()=> {
  const {fetchBlogPosts}=useContext(AppContext);

 useEffect(() => {
  fetchBlogPosts();
}, [fetchBlogPosts]);

  return (
    <div className="w-full h-full flex flex-col gap-y-1 justify-center items-center">
      <Headers></Headers>
      <Blogs ></Blogs>
      <Pagination></Pagination>
    </div>
  );
};

export default App